/**
 * Utility function to handle API errors and convert them to user-friendly messages
 * Handles both string errors and Pydantic validation error arrays
 */
export const getErrorMessage = (error, defaultMessage = "Ha ocurrido un error") => {
  const detail = error.response?.data?.detail;
  
  if (Array.isArray(detail)) {
    // Handle Pydantic validation errors (array of error objects)
    return detail.map(e => e.msg || JSON.stringify(e)).join(', ');
  }
  
  // Handle string errors or use default
  return detail || defaultMessage;
};
